import {Component} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IonicModule} from '@ionic/angular';
import config from '../../../../ngsw-config.json';
import {InactivityService, StorageService} from "../../services";
import type {AppMode} from "../../interfaces";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class FooterComponent {
  readonly version = config.appData.version;
  public mode: AppMode;
  public readonly isKioskMode$ = this.storage.isKioskMode$;

  constructor(
    private storage: StorageService,
    public readonly inactivity: InactivityService,
  ) {
    this.storage.appMode$.subscribe((mode) => {
      this.mode = mode;
    });
  }
}
